import { observer } from 'mobx-react'
import { Variant } from 'components/Button'
import { Button } from 'components/Button/styles'
import { useState } from 'react'
import { Uppercase } from 'styles/components'
import { StepType } from '../..'
import * as T from '../../styles'
import * as S from './styles'

type DataType = {
  fio?: string
  email?: string
  comment?: string
}

export const Step3 = observer(({number, currentStep, prevStep, nextStep}: StepType) => {

  const [data, setData] = useState<DataType>({fio: '', email: '', comment: ''});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setData({...data, [e.target.name]: e.target.value});

  const disabledNext = !data.fio || !data.email;

  return (
    <S.Step isActive={number === currentStep}>
      <S.Title>Как с вами связаться?</S.Title>
      <S.Form>
        <T.FormInput name='fio' placeholder='ФИО' value={data.fio} onChange={handleChange}/>
        <T.FormInput name='email' placeholder='Электронная почта' value={data.email} onChange={handleChange}/>
        <T.FormTextarea name='comment' placeholder='Комментарий' rows={4} value={data.comment} onChange={handleChange}/>
      </S.Form>
      <T.Buttons>
        <Button variant={Variant.Outline_Business} onClick={() => !!prevStep && prevStep()}><Uppercase>К предыдущему шагу</Uppercase></Button>
        <Button variant={Variant.Business} disabled={disabledNext} onClick={() => !!nextStep && nextStep(data)}>
          <Uppercase>Отправить заявку</Uppercase>
        </Button>
      </T.Buttons>
    </S.Step>
  )
})